import { client } from '@/proxy/client'
import { EDIT_ORDER as dict } from '@/resources/dict'
import { gql } from 'graphql-request'
import {
  ListProductsByCategoryData,
  ListProductsByCategoryInput,
} from '@/proxy/order/hooks/useListProductsByCategory/types'
import { useQuery } from '@/proxy/react-query'
import { toast } from 'react-toastify'

const LIST_PRODUCTS_BY_CATEGORY = gql`
  query listProductsByCategory(
    $variantId: Int!
    $categoryId: Int!
    $orderNumber: String!
    $filters: ProductsByCategoryFilters
  ) {
    listProductsByCategory(
      variantId: $variantId
      category: $categoryId
      orderNumber: $orderNumber
      filters: $filters
    ) {
      items {
        variantId
        name
        image
        categoryId
      }
    }
  }
`

export const LIST_PRODUCTS_BY_CATEGORY_KEY = 'useListProductsByCategory'

const errorHandler = () => toast.error(dict.listItemsQueryError)

export const useListProductsByCategory = (
  variables: ListProductsByCategoryInput,
  onSuccess: (data: ListProductsByCategoryData) => void,
  onError: () => void
) =>
  useQuery<ListProductsByCategoryData>({
    queryKey: [LIST_PRODUCTS_BY_CATEGORY_KEY, variables],
    queryFn: () => client.request(LIST_PRODUCTS_BY_CATEGORY, variables),

    onSuccess: data => {
      if (data?.error || !data?.listProductsByCategory) errorHandler()
      onSuccess(data)
    },

    onError: () => {
      errorHandler()
      onError()
    },
  })
